import { ItemEntrySearch } from "@models/item-entry";
import { buildSpatieSort } from "../shared/utils/buildSpatieSort";

export type ItemEntrySortField =
  | "id"
  | "business_id"
  | "item_id"
  | "sku"
  | "out"
  | "in"
  | "balance"
  | "price"
  | "account_name"
  | "account_number"
  | "created_at"
  | "updated_at";

export type ItemEntrySort = ItemEntrySortField | `-${ItemEntrySortField}`;

const ITEM_ENTRY_SORT_FIELDS: ItemEntrySortField[] = [
  "id",
  "business_id",
  "item_id",
  "sku",
  "out",
  "in",
  "balance",
  "price",
  "account_name",
  "account_number",
  "created_at",
  "updated_at",
];

export const ITEM_ENTRY_BROWSE_PER_PAGE = 5;

export interface ItemEntrySearchParams {
  itemId: number;
  filter?: Partial<ItemEntrySearch>;
  sort?: ItemEntrySort[];
  per_page?: number;
  cursor?: string;
  useCache?: boolean;
}

/**
 * Builds the POST body for the item entries Spatie browse/search endpoint.
 * @param params ItemEntrySearchParams - Browse filters, sort, and pagination.
 * @returns object - Request body fields for item-entries/search.
 */
export function getItemEntrySearchBody(params: ItemEntrySearchParams) {

  const { filter, sort, per_page = ITEM_ENTRY_BROWSE_PER_PAGE, cursor, useCache } = params;

  return {
    ...(filter && Object.keys(filter).length > 0 && { filter }),
    ...(sort?.length && { sort: sort.join(",") }),
    ...(per_page && { per_page }),
    ...(cursor && { cursor }),
    ...(useCache && { use_cache: true }),
  };
}

/**
 * Builds a Spatie sort string for item entry browse from column key and order.
 * @param sortKey string - Column field name from the item entries table.
 * @param order "ASC" | "DESC" - Sort direction from the table.
 * @returns ItemEntrySort - Spatie sort token accepted by the item entries search API.
 */
export function buildItemEntrySort(sortKey: string, order: "ASC" | "DESC"): ItemEntrySort {

  return buildSpatieSort(sortKey, order, ITEM_ENTRY_SORT_FIELDS, "id") as ItemEntrySort;
}
